import React from "react";
import {Tag, Tooltip, Typography} from "antd";
import {ColumnsType} from "antd/lib/table/interface";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import {Translate} from "../../../../hooks/translate.hook";
import {HealthCheck, HealthCheckStatus} from "../../../../models/health-checker/health-checker";
import {DashboardCheckStatus} from "./dashboard.check-status";
import {formatHealthCenterDateTime} from "../../health-center.helpers";

const {Text} = Typography;

export const columnsFactory = (t: Translate): ColumnsType<HealthCheck> => {
    return [
        {
            title: t("HEALTH-CENTER.DASHBOARD.STATUS", {defaultValue: "Status"}),
            dataIndex: "status",
            key: "status",
            width: 120,
            render: (status: HealthCheckStatus) => <DashboardCheckStatus status={status} />,
        },
        {
            title: t("HEALTH-CENTER.DASHBOARD.CHECK", {defaultValue: "Check"}),
            dataIndex: "checkerName",
            key: "checkerName",
            width: 230,
            render: (checkerName: string) => <Text strong>{checkerName}</Text>,
        },
        {
            title: t("HEALTH-CENTER.DASHBOARD.LAST-ISSUE", {defaultValue: "Last issue"}),
            dataIndex: "lastIssue",
            key: "lastIssue",
            width: 320,
            render: (issue, check) => check.status === "not_ok" && issue ? (
                <div className="health-center-dashboard__issue-cell">
                    <Tag color="error">{issue.status}</Tag>
                    <Text type="danger" className="health-center-dashboard__issue-description" title={issue.description}>
                        {issue.description}
                    </Text>
                </div>
            ) : <Text type="secondary">—</Text>,
        },
        {
            title: t("HEALTH-CENTER.DASHBOARD.LAST-CHECKED-AT", {defaultValue: "Last checked"}),
            dataIndex: "lastCheckedAt",
            key: "lastCheckedAt",
            width: 180,
            render: (value: string) => (
                <Text className="health-center-dashboard__date">{formatHealthCenterDateTime(value)}</Text>
            ),
        },
        {
            title: t("HEALTH-CENTER.DASHBOARD.NEXT-CHECK-AT", {defaultValue: "Next check"}),
            dataIndex: "nextCheckAt",
            key: "nextCheckAt",
            width: 180,
            render: (value: string) => (
                <Text className="health-center-dashboard__date health-center-dashboard__date--next">
                    <FontAwesomeIcon icon={["fas", "clock"]} /> {formatHealthCenterDateTime(value)}
                </Text>
            ),
        },
        {
            title: t("HEALTH-CENTER.DASHBOARD.HOURS", {defaultValue: "Hours"}),
            dataIndex: "hours",
            key: "hours",
            align: "right",
            width: 110,
            render: (hours: number[]) => t("HEALTH-CENTER.DASHBOARD.HOURS_VALUES", {
                hours: hours,
                defaultValue: "{{hours}}",
            }),
        },
        {
            title: "",
            key: "openIssue",
            width: 48,
            align: "right",
            render: (_, check) => check.lastIssue ? (
                <Tooltip title={t("HEALTH-CENTER.DASHBOARD.OPEN-ISSUE", {defaultValue: "Open issue"})}>
                    <Link
                        className="health-center-dashboard__issue-action"
                        to={`/health-center/issues/${check.lastIssue.id}`}
                        aria-label={t("HEALTH-CENTER.DASHBOARD.OPEN-ISSUE", {defaultValue: "Open issue"})}
                    >
                        <FontAwesomeIcon icon={["fas", "eye"]} />
                    </Link>
                </Tooltip>
            ) : null,
        },
    ];
};
